export default __webpack_public_path__ + "static/Sidebar_desktop_OTC_Logo_green-c24b6f00d23c3acb85629b4ab52329b0.svg";